import './index.css';
import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<ChakraProvider data-id="element-209">
    <App data-id="element-210" />
  </ChakraProvider>, document.getElementById("root"));